import { useState } from "react";
import { supabase } from "../lib/supabase";

export default function ForgotPasswordScreen({ onBack }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = async () => {
    setError("");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address");
      return;
    }

    setBusy(true);
    try {
      // Derive redirect URL from the current origin so it works on
      // any domain (pcos-results.emergent.host, app.pcosinsights.com, preview, etc.)
      const redirectTo = `${window.location.origin}/reset-password`;
      const { error: resetErr } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo,
      });

      if (resetErr) {
        setError(resetErr.message || "Failed to send reset link");
        setBusy(false);
        return;
      }

      setSent(true);
    } catch (err) {
      setError("Network error. Please try again.");
    }
    setBusy(false);
  };

  return (
    <div className="auth-wrapper fade-in" data-testid="forgot-password-screen">
      <div className="auth-card" style={{ background: '#FFFFFF' }}>
        <div className="auth-logo" style={{ background: 'transparent' }}>
          <img 
            src="/logo_horizontal.jpg" 
            alt="PCOS Insights" 
            style={{ maxWidth: 260, width: '85%', height: 'auto', objectFit: 'contain' }}
          />
        </div>

        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: 56, height: 56, borderRadius: '50%',
              background: '#EDE9F8', display: 'flex', alignItems: 'center',
              justifyContent: 'center', margin: '0 auto 20px'
            }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6D5EF5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
            </div>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: '#2F2F35', marginBottom: 8 }}>
              Check Your Email
            </h2>
            <p style={{ fontSize: 14, color: '#5A5A5A', lineHeight: 1.6, marginBottom: 24 }}>
              We sent a password reset link to<br />
              <strong>{email}</strong>
            </p>
            <p style={{ fontSize: 13, color: '#8A8A9A', marginBottom: 24 }}>
              Didn't receive it? Check your spam folder or try again.
            </p>
            <button
              className="btn-primary"
              onClick={onBack}
              data-testid="back-to-login-btn"
              style={{ width: '100%' }}
            >
              Back to Sign In
            </button>
          </div>
        ) : (
          <>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: '#2F2F35', textAlign: 'center', marginBottom: 4 }}>
              Reset Password
            </h2>
            <p style={{ fontSize: 14, color: '#8A8A9A', textAlign: 'center', marginBottom: 24 }}>
              Enter your email to receive a reset link
            </p>

            <div className="auth-form">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-field"
                data-testid="forgot-email-input"
                onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
              />

              {error && <p className="auth-error" data-testid="forgot-error">{error}</p>}

              <button
                className="btn-primary"
                onClick={handleSubmit}
                disabled={busy}
                data-testid="send-reset-link-btn"
                style={{ width: '100%' }}
              >
                {busy ? "Sending..." : "Send Reset Link"}
              </button>

              <p className="auth-switch" style={{ marginTop: 16 }}>
                <button
                  className="auth-switch-link"
                  onClick={onBack}
                  data-testid="back-to-login-link"
                >
                  Back to Sign In
                </button>
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
